import apiClient from '../../config/axios';

export const stripePaymentService = {
  /**
   * Creates a Stripe payment session for membership
   * @param {string} membershipListId - The membership list ID
   * @returns {Promise<Object>} - Response with sessionId and checkoutUrl
   */
  createPaymentSession: async (membershipListId) => {
    try {
      const response = await apiClient.post('/api/memberships/create-payment-session', {
        membershipListId: membershipListId,
      });
      
      return {
        success: true,
        sessionId: response.data.sessionId,
        checkoutUrl: response.data.checkoutUrl,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Errore nella creazione della sessione di pagamento',
      };
    }
  },

  /**
   * Redirects to Stripe checkout
   * @param {string} checkoutUrl - The Stripe checkout URL
   */
  redirectToCheckout: (checkoutUrl) => {
    window.location.href = checkoutUrl;
  },
}; 